export const firebaseConfig = {
    apiKey: "AIzaSyDk7LMB1MvXNeTZM4jxntH-C3v8H4eyWhc",
    authDomain: "a-void-society.firebaseapp.com",
    databaseURL: "https://a-void-society.firebaseio.com",
    projectId: "a-void-society",
    storageBucket: "a-void-society.appspot.com",
    messagingSenderId: "866167593309",
    appId: "1:866167593309:ios:b39cf63fe84dc725",
    measurementId: "G-WTNM46VW3J"
};